import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  cta: {
    id: 'seo_blue_beetle_communicate_cta_3',
  },
  learnablesLabel: {
    id: 'seo_blue_beetle_communicate_words',
  },

  topic: {
    id: 'seo_blue_beetle_communicate_title',
  },
});

export const en = defineMessages({
  text: {
    id: 'seo_blue_beetle_communicate_description_en',
  },
  title: {
    id: 'seo_blue_beetle_communicate_subtitle_en',
  },
});

export const en_us = defineMessages({
  text: {
    id: 'seo_blue_beetle_communicate_description_en_us',
  },
  title: {
    id: 'seo_blue_beetle_communicate_subtitle_en_us',
  },
});

export const es = defineMessages({
  text: {
    id: 'seo_blue_beetle_communicate_description_es',
  },
  title: {
    id: 'seo_blue_beetle_communicate_subtitle_es',
  },
});

export const es_mx = defineMessages({
  text: {
    id: 'seo_blue_beetle_communicate_description_es_mx',
  },
  title: {
    id: 'seo_blue_beetle_communicate_subtitle_es_mx',
  },
});
